import { render, staticRenderFns } from "./ButtonSetSmallAction.vue?vue&type=template&id=2363a411&"
import script from "./ButtonSetSmallAction.vue?vue&type=script&lang=js&"
export * from "./ButtonSetSmallAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports